import { Resources } from 'constants/resources';

import { useMutation } from '@tanstack/react-query';
import { updateRelatedBankOperation } from 'config/requests/bankOperations';
import { transformRelatedData } from 'pages/Finance/RequestsBankOps/utils/transformRelatedData';
import { queryClient } from 'providers/queryClient';
import { useNotify, useRedirect } from 'react-admin';
import { BankOperation } from 'types/embedded/bankOperation';
import { getId } from 'utils/getId';

export function useUpdateRelatedBankOperation(setErrors: (e: any) => void) {
  const redirect = useRedirect();
  const notify = useNotify();

  const { mutate: updateRelated } = useMutation({
    mutationFn: (data: BankOperation) => {
      return updateRelatedBankOperation(transformRelatedData(data));
    },
    onError: (e: any) => {
      setErrors(e?.data.errors);
    },
    onSuccess: async (data: BankOperation) => {
      await queryClient.invalidateQueries({ queryKey: [Resources.RequestBankOperations] });
      redirect('list', Resources.RequestBankOperations);

      notify(`Заявка на банковскую операцию ID ${getId(data?.id)} удалена`, {
        type: 'success',
      });
    },
  });

  return { updateRelatedBankOperation: updateRelated };
}
